import { withFullScreen } from '@/components/FullScreen';
import { MediaInvestmentTableBase } from './MediaInvestmentTable';

export const MediaInvestmentTable = withFullScreen(
    'MediaInvestmentTable',
    MediaInvestmentTableBase,
    { fullScreenDisabled: false },
);
